import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TitanIconComponent } from 'src/app/user-interface/titan-icon/titan-icon.component';

@Component({
  selector: 'app-typing-indicator',
  templateUrl: './typing-indicator.component.html',
  styleUrls: ['./typing-indicator.component.scss'],
  standalone: true,
  imports: [CommonModule, TitanIconComponent]
})
export class TypingIndicatorComponent {
  @Input() text = 'Analyzing your request...';
}
